export default store => store.historyLocation;
